import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=594047ce&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=594047ce&prod&scoped=true&lang=css"
import style1 from "./ChatBox.vue?vue&type=style&index=1&id=594047ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594047ce",
  null
  
)

export default component.exports